import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const base64UrlToUint8Array = (value) => {
  const padding = '='.repeat((4 - (value.length % 4)) % 4);
  const base64 = (value + padding).replace(/-/g, '+').replace(/_/g, '/');
  const binary = window.atob(base64);
  return Uint8Array.from(binary, (character) => character.charCodeAt(0));
};

const headersFor = (token) => ({ Authorization: `Bearer ${token}` });

export const supportsPushNotifications = () => (
  'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window && window.isSecureContext
);

export const getPushStatus = async (token) => {
  const response = await axios.get(`${API}/push/status`, { headers: headersFor(token) });
  return response.data;
};

export const enablePushNotifications = async (token) => {
  if (!supportsPushNotifications()) {
    throw new Error('Push notifications require a supported browser over HTTPS.');
  }

  const permission = await Notification.requestPermission();
  if (permission !== 'granted') {
    throw new Error('Notification permission was not granted.');
  }

  const registration = await navigator.serviceWorker.ready;
  let subscription = await registration.pushManager.getSubscription();
  if (!subscription) {
    const keyResponse = await axios.get(`${API}/push/public-key`);
    subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: base64UrlToUint8Array(keyResponse.data.public_key)
    });
  }

  const subscriptionJson = subscription.toJSON();
  await axios.post(`${API}/push/subscription`, {
    endpoint: subscriptionJson.endpoint,
    keys: subscriptionJson.keys
  }, { headers: headersFor(token) });
};

export const disablePushNotifications = async (token) => {
  const registration = await navigator.serviceWorker.ready;
  const subscription = await registration.pushManager.getSubscription();
  if (!subscription) return;

  await axios.delete(`${API}/push/subscription`, {
    data: { endpoint: subscription.endpoint },
    headers: headersFor(token)
  });
  await subscription.unsubscribe();
};

export const sendPushTest = async (token) => {
  await axios.post(`${API}/push/test`, {}, { headers: headersFor(token) });
};